import useUser from "@/api/apis";
import { useLocale } from "@/store/locale-store";
import { Env, isProd } from "@/Env";

const allowedEmailSet: Set<string> | null = (() => {
  const raw = process.env.NEXT_PUBLIC_NAVERPAY_ALLOWED_EMAILS;
  if (!raw) return null;
  return new Set(raw.split(",").map((e) => e.trim()));
})();

export function useNaverPayEnabled(): boolean {
  const { countryCode } = useLocale();
  const { user } = useUser();

  if (countryCode !== "KR") return false;
  if (!Env.NaverPay.ButtonKey) return false;

  // 비운영 환경(local, development)은 항상 노출
  if (!isProd) return true;

  // 허용 이메일 목록이 없으면 전체 노출 (검수 완료 후)
  if (!allowedEmailSet) return true;

  // 허용 이메일 목록이 있으면 로그인 유저의 이메일 확인
  return user?.email ? allowedEmailSet.has(user.email) : false;
}
